module.exports = __webpack_public_path__ + "static/family2-61485405c377895cfefe2457a82b4b8b.png";